import { computed, defineComponent } from 'vue'
import type { IGlobalErrorProps } from './types'
import Icon from '../icon'
import Navbar from '../navbar'
import { useUserStore } from '@/stores/user'
import Button from '../button'


export const GlobalError = defineComponent<IGlobalErrorProps>(
  (props) => {
    const userStore = useUserStore();
    const router = useRouter();
    const isLoggedIn = computed(() => userStore.user && userStore.user._id && userStore.user._id !== '_');

    const goBack = () => {
      clearError().catch(e => console.error(e));
      router.back();
    }
    const goToDashboard = () => {
      clearError({
        redirect: '/'
      })
    }

    return () => {
      return (
        <div class="w-full h-full flex flex-col">
          {isLoggedIn.value && <div class="w-full">
            <Navbar style={{ maxWidth: '100%' }} />
          </div>}
          {!isLoggedIn.value && <div class="h-20 flex-none flex items-center px-5 justify-between">
            <Icon
              src={{
                src: async () => import('assets/logo-blue.svg?url'),
                size: '6rem'
              }}
            />
            <a class="flex items-center gap-2" href="https://findex.se" target="_blank">
              <div class="text-center text-primary-500 text-sm font-bold font-['Inter'] leading-[21px]">
                www.findex.se
              </div>
              <Icon
                src={{
                  src: async () => import('assets/img/svg/icons/arrow-right-bracket.svg?url'),
                  size: '1rem',
                  fill: '#3f83f8'
                }}
              />
            </a>
          </div>}
          <div class="w-full h-full flex items-center justify-center flex-1">
            <div class="text-center space-y-6">
              <div class="w-16 h-16 bg-gray-100 rounded-xs justify-center items-center inline-flex text-gray-400">
                <Icon
                  src={{
                    src: async () => import('assets/img/svg/icons/info-circle.svg?url'),
                    fill: 'currentColor',
                    size: '2.15rem'
                  }}
                />
              </div>
              <div class="text-center">
                <div class="flex flex-col gap-2">
                  <div class="text-black text-base font-semibold font-['Inter'] leading-none">
                    {props.title}
                  </div>
                  <div class="text-gray-500 text-sm font-normal font-['Inter'] leading-[21px] max-w-108">
                    {props.subtitle}
                  </div>
                </div>
                {isLoggedIn.value &&
                  <div class="flex flex-row gap-2 mt-8">
                    <Button
                      class="w-[50%]"
                      outlined
                      transparent
                      onClick={goBack}
                    >Go Back</Button>
                    <Button
                      class="w-[50%]"
                      onClick={goToDashboard}
                    >Dashboard</Button>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="w-full min-h-24 text-center flex flex-col items-center justify-start flex-none">
            <div>
              <span class="text-gray-500 text-sm font-normal font-['Inter'] leading-[21px]">
                If you have any questions, please{' '}
              </span>
              <span class="text-primary-500 text-sm font-bold font-['Inter'] underline leading-[21px]">
                Contact Us
              </span>
              <span class="text-gray-500 text-sm font-normal font-['Inter'] leading-[21px]">
                {' '}
                and we’ll help you out!
              </span>
            </div>
          </div>
        </div>
      )
    }
  },
  { props: ['title', 'subtitle'] }
)
